var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenewed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 1)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#01A36D",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.89 29.022 10.284 10.284C33.69 37.035 40 29.274 40 20v-.568l-8.076-7.445L14.89 29.022z",
    fill: "#04704C"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.505 24.48c.883.883.883 2.397 0 3.28l-1.83 1.83c-.883.883-2.397.883-3.28 0l-8.013-8.076c-.884-.883-.884-2.397 0-3.28l1.83-1.83c.883-.883 2.397-.883 3.28 0l8.013 8.075z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.508 10.536c.883-.883 2.397-.883 3.28 0l1.83 1.83c.884.883.884 2.397 0 3.28l-13.88 13.818c-.883.883-2.397.883-3.28 0l-1.83-1.83c-.884-.883-.884-2.397 0-3.28l13.88-13.818z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewed);
export default __webpack_public_path__ + "static/media/renewed.cb8b9ea07dae679ae6a800fb47d8c11b.svg";
export { ForwardRef as ReactComponent };